const breadcrumbs = Object.freeze({
  home: "Головна",
  vacancies: "Вакансії",
  jobs: "Робота",
  companies: "Компанії",
});

export default breadcrumbs;
